module.exports = __webpack_public_path__ + "static/media/ChevronLeft.8d31de4d.svg";